const availableLanguages = {
    en: "English",
    es: "Spanish"
}

export {
    availableLanguages
}